<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field">
        <p-dropdown [options]="modules" [(ngModel)]="filters.module.value" (onChange)="search()"
            placeholder="Módulo" showClear [filter]="true" appendTo="body"
            styleClass="w-full"></p-dropdown>
    </span>
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="products" [lazy]="true" (onLazyLoad)="loadData($event)"
    [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
    [sortField]="'module'" [sortOrder]="1">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="module">Módulo <p-sortIcon field="module"></p-sortIcon></th>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="price">Precio <p-sortIcon field="price"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-columns="columns">
        <tr (dblclick)="edit(product)">
            <td>{{product.module}}</td>
            <td>{{product.name}}</td>
            <td>{{product.price | currency:'EUR':'symbol':'1.2-5'}}</td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowWrite" (click)="edit(product)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
